import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type PaymentVoidParams = {
  id: string;
};

export const paymentVoidAtom = createMutationAtomFactory(
  'finance.paymentVoid',
  (params: PaymentVoidParams) => ({
    financePaymentVoid: {
      __args: {
        id: params.id,
      },
      id: true,
      documentNumber: true,
      status: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
